module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"attach_note":"Attach note","new_note":"New note","notes_not_found":"Notes not found or empty"},"id":{"attach_note":"Tetapkan nota","new_note":"nota baru","notes_not_found":"Tiada Nota"}}')
  delete Component.options._Ctor
}
